import { Link } from 'react-router-dom'
import { BookOpen } from 'lucide-react'
import { AccountMenu } from '@/components/layout/AccountMenu'
import { NotificationBell } from '@/components/layout/NotificationBell'
import { TenancySwitcher } from '@/components/layout/TenancySwitcher'
import { VersionChip } from '@/components/layout/VersionChip'
import { AuditCenterLink } from '@/components/layout/AuditCenterLink'
import { ShiftDashboardLink } from '@/components/layout/ShiftDashboardLink'
import { MyTasksLink } from '@/components/layout/MyTasksLink'
import { SupportHeaderLinks } from '@/components/support/SupportHeaderLinks'
import { PipelineReportLink } from '@/components/layout/PipelineReportLink'
import { ViewModeSwitcher } from '@/components/ViewModeSwitcher'
import { OverallStatusLink } from '@/components/board/OverallStatusLink'
import { HomeNavPanel } from '@/components/home/HomeNavPanel'
import { HomeDashboard } from '@/components/dashboard/HomeDashboard'

/**
 * Home: the app tiles on the left, the user's own dashboard on the right
 * (z8nrz7eqyv). The dashboard is configurable per user and per tenant; see
 * HomeDashboard. Every number on it is live: the hard-coded sample panels this
 * page used to show are gone.
 */
export function DashboardPage() {
  return (
    <div className='flex h-full overflow-hidden'>
      <HomeNavPanel />

      {/* Right: Dashboard */}
      <div className='flex flex-1 flex-col overflow-hidden'>
        {/* My Dashboard Header */}
        <div className='flex shrink-0 items-center gap-4 border-b border-gray-200 bg-white px-6 py-3'>
          {/* Visually removed to give the header room; kept for screen readers,
              which still need a page heading. */}
          <h1 className='sr-only'>My Dashboard</h1>
          <div className='flex-1' />
          {/* TopBar is hidden on /dashboard (Layout), so the tenancy switcher,
              the Wiki and report links and the view-mode switcher must all live here too:
              this is the page login lands on, and without them it has no way to
              change tenant, reach the wiki, or leave for the mobile view. */}
          <AuditCenterLink />
          <ShiftDashboardLink />
          <MyTasksLink />
          <SupportHeaderLinks />
          <OverallStatusLink placement='topbar' />
          <VersionChip />
          <TenancySwitcher />
          <Link
            to='/wiki'
            title='Wiki'
            className='flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600'
          >
            <BookOpen className='h-4 w-4' />
          </Link>
          <PipelineReportLink className='flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600' />
          <div className='h-4 w-px bg-gray-200' />
          <ViewModeSwitcher />
          <NotificationBell />
          <AccountMenu />
        </div>

        {/* Scrollable content */}
        <div className='flex-1 overflow-y-auto bg-gray-50 p-5'>
          <HomeDashboard />
        </div>
      </div>
    </div>
  )
}
